import type { BackgroundNoImageProtocol } from '@lighthouse/core'
import { TABS_TYPE, type TabsType } from '@lighthouse/core'
import type { FC } from 'react'
import React from 'react'

import { CardSlotTabs } from './CardSlotTabs'
import { LineTabs } from './LineTabs'
import { RoundTabs } from './RoundTabs'
import { SegmentedTabs } from './SegmentedTabs'
import type { BaseTabsProps } from './Tabs.type'

interface TabsProps extends BaseTabsProps {
    mode?: TabsType
    scale?: number
}

export const Tabs: FC<TabsProps> = ({ mode, scale, ...rest }) => {
    switch (mode) {
        case TABS_TYPE.LINE: {
            return <LineTabs scale={scale} {...rest} />
        }

        case TABS_TYPE.CARD_SLOT: {
            return <CardSlotTabs {...rest} />
        }

        case TABS_TYPE.ROUND: {
            return <RoundTabs {...rest} />
        }

        case TABS_TYPE.SEGMENTED: {
            return <SegmentedTabs {...rest} />
        }

        default: {
            return null
        }
    }
}
